import { Tabs } from 'antd';

import { viewerModel } from 'entities/viewer';

import { RolesUser } from 'shared/enums';
import { configTabs } from 'shared/helpers/utils';
import { useTabsNavigate } from 'shared/hooks';
import { useAppSelector } from 'app/store';
import { TItemsTab } from 'shared/types/types';

import Employees from './employees';
import EmployeesBlocked from './employeesBlocked';
import style from './index.module.scss';
import Admins from './admins';
import AdminsBlocked from './adminsBlocked';

const itemsTab: TItemsTab = [
  {
    label: 'Пользователи',
    key: 'employees',
    children: <Employees />,
    role: [RolesUser.HRDirector, RolesUser.Consultant, RolesUser.FirstLine],
  },
  {
    label: 'Администраторы',
    key: 'admins',
    children: <Admins />,
    role: [RolesUser.HRDirector],
  },
  {
    label: 'Заблокированные пользователи',
    key: 'blocked_users',
    children: <EmployeesBlocked />,
    role: [RolesUser.HRDirector, RolesUser.Consultant, RolesUser.FirstLine],
  },
  {
    label: 'Заблокированные администраторы',
    key: 'admins_users',
    children: <AdminsBlocked />,
    role: [RolesUser.HRDirector],
  },
];

const Controls = () => {
  const [activeTab, handler] = useTabsNavigate('controls', itemsTab[0].key);
  const { role } = useAppSelector(viewerModel.me.selectors.selectViewerProfile);
  const tabPane = configTabs(role, itemsTab);

  return (
    <>
      <div className={style.wrap}>
        {role && (
          <Tabs activeKey={activeTab} onChange={handler} destroyInactiveTabPane>
            {tabPane &&
              tabPane?.map(el => {
                return (
                  <Tabs.TabPane tab={el.label} key={el.key}>
                    {el.children}
                  </Tabs.TabPane>
                );
              })}
          </Tabs>
        )}
      </div>
    </>
  );
};

export default Controls;
